import axiosHelper from "../../../../axiosHelper";
import { APIUSEROLD, API_FAILURE, GET_ALL_PAYMENT_MASTER } from "../../../../config/constants";
import { apiErrors } from "../../../../helper";

export function fetchAllPaymentMaster(filter, callback) {
  return (dispatch) => {
    const request = axiosHelper.get(`${APIUSEROLD.getAllPaymentsMaster}`, {
      params: {
        page: filter.current_page,
        pageSize: filter.per_page,
        SearchType: filter?.sortField?.supplierName,
        SortBy: filter?.sortField,
        SortOrder: filter.sortOrder,
      }, // Assuming filter contains necessary query parameters
    });
    request
      .then((response) => {

        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_ALL_PAYMENT_MASTER,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          // callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
      } else{

        callback(null, error);
      }
        // apiErrors(error);
      });
  };
}
export function addNewPaymentMaster(data, callback) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.addPaymentMaster, data)
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data)
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE })
        if (error.response.status === 401) {
          apiErrors(error)
      } 
      })
  }
}
export function getPaymentMasterDetailById(id) {
  const request = axiosHelper.get(`${APIUSEROLD.getPaymentDetailById}?Id=${id}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
    } else{

      throw error; // Re-throw the error to the caller
    }
    });
}
export function deletePaymentMaster(id, callback) {
  axiosHelper
    .delete(`${APIUSEROLD.deletePaymentMaster}?id=${id}`)
    .then((response) => {
      if (callback) {
        callback(null, response); // Call the callback with null for the error parameter and the response
      }
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
    } else{

      if (callback) {
        callback(error, null); // Call the callback with the error and null for the response
      }
    }
    });
}

export function activeInactivePaymentMasterList(requestData, callback) {
  return (dispatch) => {
    // dispatch({ type: API_REQUEST });
    axiosHelper.put(`${APIUSEROLD.activeInactivePaymentMasterList}`, requestData)
      .then((response) => {
        // dispatch({ type: API_SUCCESS });
        callback(response);
      }).catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
      } 
      });
  };
}